import { Translations } from '../../types/i18n';

export const es: Translations = {
  welcome: {
    title: 'Bienvenido',
    subtitle: '¿Me podrías decir tu nombre?',
    description: '¡No es necesario pero hará una mejor experiencia!',
    nameLabel: 'Nombre',
    namePlaceholder: 'Escribe tu nombre aquí...',
    submitButton: '¡Este es mi nombre!',
    skipButton: 'Prefiero no...',
    cookieNotice: 'Al continuar, aceptas el uso de cookies para mejorar la experiencia.',
    switchToLight: 'Cambiar a modo claro',
    switchToDark: 'Cambiar a modo oscuro',
  },
  navigation: {
    home: 'Inicio',
    about: 'Sobre mí',
    work: 'Trabajo',
    portfolio: 'Portafolio',
    contact: 'Contacto',
    games: 'Juegos',
  },
  avatar: {
    chooseOption: 'Elige una opción',
    actions: {
      sayHi: 'Saludar',
      meow: '¡Miau!',
      playGames: 'Jugar',
      leave: 'Salir',
      doingFine: 'Estoy bien, gracias.',
      talkWork: '¡Hablemos de trabajo!',
      tellMore: 'Cuéntame más sobre ti',
      howContact: '¿Cómo puedo contactarte?',
      hearJoke: '¡Quiero escuchar un chiste!',
      randomFact: '¡Dame un dato curioso!',
      seePortfolio: '¿Puedo ver tu portafolio?',
      somethingInteresting: '¡Cuéntame algo interesante!',
      showPortfolio: '¡Muéstrame tu portafolio!',
      letsPlayGames: '¡Juguemos!',
      freeChat: 'Chat Libre',
    },
    dialogues: {
      greeting: '¡Hola, viajero del internet!',
      greetingWithName: '¡Hola, {name}!',
      howAreYou: '¿Cómo estás hoy? ¿Puedo ayudarte en algo? :)',
      howAreYouWithName: '¿Cómo estás hoy, {name}? ¿Puedo ayudarte en algo? :)',
      goodbye: '¡Bueno... Adiós!',
      likeCats: '¿Te gustan los gatos? Estos son Ralph y Atreyu',
      gladFine: 'Me alegra mucho que estés bien. :)',
      readAboutMe: '¡Claro, puedes leer más sobre mí en la ventana del navegador! :)',
      lookAtBrowser: 'Claro, echa un vistazo a la ventana del navegador.',
      contactLinks:
        '¡Puedes contactarme a través de cualquiera de los enlaces de arriba. O también puedes dejarme un mensaje en el formulario de contacto!',
      projectsWorkedOn: 'Estos son algunos de los proyectos en los que he trabajado recientemente.',
      letsPlayGames: '¡Genial! ¡Juguemos! Puedes encontrar los juegos en la barra de navegación.',
      dontPoke: '¡Por favor no me toques!',
      dontPokeWithName: '¡Por favor no me toques, {name}!',
      notFunLeaving: 'Ok, esto no es divertido, me voy.',
      freeChatIntro: '¡Genial, quieres charlar libremente? ¡Pregúntame lo que sea! :)',
      freeChatError: 'Hmm, algo salió mal. ¡Intenta de nuevo!',
      freeChatExit: '¡Eso fue divertido! ¿Qué más te gustaría hacer?',
      radioPlay: '¡Esa es mi música! Puedes escuchar más en mi SoundCloud. ¡Mira los enlaces de arriba! :)',
    },
    chat: {
      placeholder: 'Escribe un mensaje...',
      send: 'Enviar',
      exit: 'Salir del Chat',
      thinking: 'Pensando...',
    },
    fallbackJokes: [
      '¿Por qué los científicos no confían en los átomos? ¡Porque lo inventan todo!',
      '¿Por qué el espantapájaros ganó un premio? ¡Era sobresaliente en su campo!',
      '¿Por qué los huevos no cuentan chistes? ¡Se romperían de la risa!',
      '¿Cómo se llama un fideo falso? ¡Un impasta!',
      '¿Por qué el café presentó una denuncia policial? ¡Le habían robado!',
    ],
    fallbackFacts: [
      '¡La miel nunca se echa a perder! Los arqueólogos han encontrado vasijas de miel en tumbas egipcias de más de 3,000 años.',
      'Un grupo de flamencos se llama "flamboyance" en inglés.',
      '¡Los plátanos son bayas, pero las fresas no!',
      'La guerra más corta de la historia duró solo 38 minutos.',
      '¡Los pulpos tienen tres corazones y sangre azul!',
    ],
  },
  home: {
    title: '¡Bienvenido a mi sitio web!',
    welcomeText: 'Soy Maw, Desarrollador Full-Stack Senior.',
    exploreText:
      '¡Explora mi trabajo, revisa mi portafolio, o ponte en contacto usando la navegación de arriba!',
    tipsText:
      '💡 ¡Esto no es solo un sitio web, es todo un navegador! Cambia el idioma 🌐 o el modo día/noche ☀️🌙 desde el menú Editar (o la barra de estado de abajo), elige un tema del navegador 🎨 en el menú Ver, cambia tu nombre en el menú Archivo, y abre Ayuda para ver los atajos de teclado.',
    quickLinks: 'Enlaces Rápidos',
    viewPortfolio: 'Ver Portafolio',
    downloadResume: 'Descargar CV',
    contactMe: 'Contáctame',
    visitorNumber: 'Eres el visitante #{number}',
    bestViewed: 'Mejor visualizado en Netscape Navigator 4.0 a 800x600',
    checkOutProjects: '¡Mira mis últimos proyectos!',
    loveToHear: '¡Me encantaría saber de ti!',
  },
  about: {
    title: 'Sobre Mí',
    role: 'Desarrollador Full-Stack Senior & Líder Técnico',
    welcomeText:
      '¡Bienvenido a mi rincón de la web! Soy graduado en Informática con más de 15 años de experiencia en desarrollo web (desde 2009).',
    specializeText:
      'Me especializo en construir aplicaciones escalables y liderar equipos técnicos. Mi experiencia abarca ecosistemas modernos de JavaScript/TypeScript, infraestructura en la nube y tecnologías emergentes Web3.',
    deliveredText:
      'A lo largo de mi carrera, he entregado soluciones para clientes que van desde startups hasta empresas en sectores fintech, e-commerce y Web3.',
    downloadResume: 'Descargar Mi CV',
    keySkills: 'Habilidades Clave',
    visitorNumber: 'Eres el visitante #{number}',
    experienceText: '',
  },
  work: {
    title: 'Stack Tecnológico',
    categoryDescriptions: {
      all: 'Con más de 15 años en desarrollo web, he dominado un stack tecnológico completo.',
      frontend:
        'Más de 10 años creando interfaces responsivas y de alto rendimiento con frameworks modernos.',
      backendData:
        'Construyendo APIs escalables, microservicios y arquitecturas de datos con SQL, NoSQL y blockchain desde 2012.',
      platforms:
        'Desplegando y gestionando aplicaciones en plataformas CMS, infraestructura cloud y hosting.',
      tools:
        'Optimizando flujos de trabajo con herramientas de desarrollo, CI/CD, diseño y automatización.',
    },
    categories: {
      all: 'Todo',
      frontend: 'Frontend',
      backendData: 'Backend y Datos',
      platforms: 'Plataformas',
      tools: 'Herramientas',
    },
    viewProjects: 'Ver Mis Proyectos',
    followOnGithub: 'Sigue mis últimos experimentos en',
    totalDownloads: 'Descargas Totales: {count}',
    showTechnologies: '¡Déjame mostrarte lo que he construido con estas tecnologías!',
  },
  portfolio: {
    title: 'Portafolio',
    clickToView: '¡Haz clic en las imágenes para ver demos en vivo!',
    loadingProjects: 'Cargando proyectos...',
    noProjects: 'No hay proyectos disponibles en este momento.',
    featuredProject: 'Proyecto Destacado: {name}',
    visitProject: 'Visitar Proyecto',
    getInTouch: 'Contactar',
    projectsAvailable: '{count} Proyectos Disponibles',
    loveToHear: '¡Me encantaría saber de ti!',
    categories: {
      all: 'Todos',
      professional: 'Profesional',
      web3: 'Web3',
      experiments: 'Experimentos',
    },
  },
  contact: {
    title: '¡Contáctame!',
    subtitle: 'No dudes en dejar un mensaje. ¡Te responderé lo antes posible!',
    nameLabel: 'Nombre:',
    namePlaceholder: 'Tu nombre',
    emailLabel: 'Email:',
    emailPlaceholder: 'tu@email.com',
    messageLabel: 'Mensaje:',
    messagePlaceholder: 'Escribe tu mensaje aquí...',
    sendButton: 'Enviar Mensaje',
    sending: 'Enviando...',
    successMessage: 'Mensaje enviado exitosamente.',
    visitorsSigned: '¡{count} visitantes firmaron!',
  },
  browser: {
    menus: {
      file: 'Archivo',
      edit: 'Editar',
      view: 'Ver',
      favorites: 'Favoritos',
      themes: 'Temas',
      help: 'Ayuda',
    },
    themes: {
      classic: 'Clásico',
      vaporwave: 'Vaporwave',
      terminal: 'Terminal',
      notebook: 'Cuaderno',
    },
    titles: {
      home: 'Bienvenido a Maw.dev - Web Explorer',
      about: 'Sobre Mí - Web Explorer',
      work: 'Stack Tecnológico - Web Explorer',
      portfolio: 'Galería de Portafolio - Web Explorer',
      contact: 'Formulario de Contacto - Web Explorer',
      games: 'Juegos - Web Explorer',
    },
    bsod: {
      title: ':(',
      mainText: 'Tu PC tuvo un problema y necesita reiniciarse.',
      collectingError: 'Solo estamos recopilando información del error, y luego reiniciaremos.',
      errorCode: 'CRITICAL_PROCESS_DIED',
      stopCode: 'Código de error: 0x000000EF',
      clickToRestart: 'Haz clic en cualquier lugar para reiniciar...',
    },
    statusDone: 'Listo',
    statusZone: 'Internet',
    settings: {
      title: 'Configuración',
      language: 'Idioma',
      mode: 'Modo',
      theme: 'Tema',
      dayMode: 'Modo Día',
      nightMode: 'Modo Noche',
      changeName: 'Cambiar Nombre...',
      showWelcome: 'Mostrar Bienvenida',
    },
    help: {
      title: 'Ayuda',
      navigation:
        'Usa la barra de menú o las pestañas de navegación para explorar las secciones del sitio.',
      sections: 'Secciones: Inicio, Sobre Mí, Stack Tecnológico, Portafolio, Contacto y Juegos.',
      themes: 'Cambia el tema visual en Ver, o alterna Modo Día/Noche en Editar.',
      contact: 'Contáctame a través de la página de Contacto o encuéntrame en GitHub.',
      easterEggs: '¡Intenta hacer clic por ahí — podría haber sorpresas!',
      ok: 'OK',
    },
    favorites: {
      linkedin: 'LinkedIn',
      github: 'GitHub',
      soundcloud: 'SoundCloud',
    },
    pause: {
      title: 'Pausado',
      hint: 'Haz clic en cualquier lugar para continuar',
    },
  },
  games: {
    title: 'Juegos',
    subtitle: 'Selecciona un juego para comenzar a jugar',
    racing: {
      title: 'Carreras',
      description: 'Velocidad 3D',
      startRacing: '¡Empezar a Correr!',
      useKeyboard: '¡Usa el teclado para correr!',
      useTouchControls: '¡Usa los controles táctiles para correr!',
      turnLeft: 'Girar a la izquierda',
      turnRight: 'Girar a la derecha',
      accelerate: 'Acelerar',
      brake: 'Frenar',
      collectCoins: '¡Recolecta monedas y evita chocar con otros autos!',
      pressEscContinue: 'Presiona ESC para continuar',
      or: 'o',
    },
    tetris: {
      title: 'Tetris',
      description: 'Puzzle Clásico',
    },
    snake: {
      title: 'Snake',
      description: 'Come y Crece',
    },
    flappyBird: {
      title: 'Flappy Bird',
      description: 'Vuela Alto',
    },
    breakout: {
      title: 'Breakout',
      description: 'Rompe Ladrillos',
    },
    penaltyShootout: {
      title: 'Penales',
      description: 'Mete Goles',
    },
    candyCrush: {
      title: 'Candy Crush',
      description: 'Combina Dulces',
    },
    rhythmHighway: {
      title: 'Rhythm Highway',
      description: 'Sigue el Ritmo',
    },
    pacMan: {
      title: 'Pac-Man',
      description: 'Come Puntos',
    },
    soccerJuggling: {
      title: 'Dominadas',
      description: 'Mantén el Balón',
    },
    congratulations: '¡Felicidades!',
    sorry: '¡Lo sentimos!',
    wonPoints: 'Ganaste {points} puntos',
    tryAgain: 'Intenta de nuevo',
    backToMenu: 'Volver al Menú de Juegos',
    readyToPlay: 'LISTO PARA JUGAR',
    pause: 'PAUSA',
    gameOver: 'FIN DEL JUEGO',
    levelComplete: '¡NIVEL COMPLETADO!',
    finalScore: 'Puntuación Final',
    level: 'Nivel',
    pressSpaceToStart: 'PRESIONA ESPACIO PARA COMENZAR',
    continue: 'Continuar',
    quit: 'Salir',
    leaderboard: 'Tabla de Posiciones',
    enterName: 'Ingresa tu nombre',
    saveScore: 'Guardar Puntaje',
    skip: 'Omitir',
    noScoresYet: 'Sin puntajes aún. ¡Sé el primero!',
    newHighScore: '¡Nuevo Récord!',
  },
};
